( function() {
    const anchorLinks = document.getElementById('js-toggle-filters'),
        filtersContainer = document.getElementById('js-library-filters');

    anchorLinks.addEventListener('click', (item) => {
        anchorLinks.classList.toggle('active');
        filtersContainer.classList.toggle('active');
    });

    /**
	 * Handles function calls in major breakpoints.
	 */
	const initEnquire = () => {

        enquire.register("screen and (min-width:960px)", {
            match : function() {
                anchorLinks.classList.remove('active');
                filtersContainer.classList.add('active');
            },
            unmatch : function() {
                filtersContainer.classList.remove('active');
            }
        });
	}

    // TODO: add enquire for removing active classes when sizing up

    document.addEventListener('DOMContentLoaded', () => {
        initEnquire();
    });

}() );
